import styled from 'styled-components';

import { Colors } from '../../../Foundation/Colors';

export const StyledFlatPanel = styled.div`
  background-color: ${Colors.grey_blue_0};
  padding: 16px;
`;
